import React, { useRef, useState,useEffect, useContext } from 'react';
import styles from '../styles.module.css';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { data as PieData, focusPie, sectionAutoFocusPie } from '../../PieChart/data';
import { FaArrowAltCircleLeft } from 'react-icons/fa';
import { AppContext } from '../../../AppContext';

const donutCode=`import { PieChart } from "react-native-gifted-charts";
        
const App = () => {
    const pieData = [
        {value: 54, color: '#177AD5', text: '54%'},
        {value: 40, color: '#79D2DE', text: '30%'},
        {value: 20, color: '#ED6665', text: '26%'},
    ];
    
    return(
        <View>
            <PieChart
            donut
            showText
            textColor="black"
            radius={150}
            textSize={20}
            showTextBackground
            textBackgroundRadius={26}
            data={pieData}
            />
    </View>
    )
};`
const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
const PieChartGallery=props=>{
    const appContext = useContext(AppContext);
    const{isMobile} = appContext;
    const [isPlaying,setIsplaying]=useState(false)
    const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    }
  },[])
  
  const updateWindowWidth = () => {
    setWidth(window.innerWidth)
  }
    const videoRef=useRef();
    const onplayClick=()=>{
        if(isPlaying){
            videoRef.current.pause();
            setIsplaying(false)
        }
        else{
            videoRef.current.play();
            setIsplaying(true)
        }
    }
    const onVideoEnd=()=>{
        setIsplaying(false)
    }
    return(
        <div className={styles.container}>
            <FaArrowAltCircleLeft
            onClick={()=>{window.location.pathname="/gallery"}}
            style={{fontSize:30,position:'absolute',cursor:'pointer',top:isMobile?70:110}}/>
            <h2>
                Pie Chart Examples
                <a style={{marginLeft:20,fontSize:15}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/PieChart/PieChartProps.md' rel="noreferrer">
                    props table
                </a> 
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <div className={styles.boxStyle}>
                    <img
                    src={PieData[2].imgSrc}
                    className={styles.barOutput}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {PieData[2].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                    src={require('../../../assets/donut.png')}
                    className={styles.barOutput}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {donutCode}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                    src={'https://user-images.githubusercontent.com/20596944/170603008-1a5628f0-61fa-4e5b-b9dd-d673f9ae21d3.gif'}
                    className={styles.barOutput}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {focusPie}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                <img
                    src={'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/screenshots/sectionAutoFocus.png?raw=true'}
                    style={{borderRadius:20, width: 360}}
                    alt=''/>
                <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                    {sectionAutoFocusPie}
                </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                    src={PieData[5].imgSrc}
                    className={styles.threedoutput}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {PieData[5].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                    src={PieData[7].imgSrc}
                    className={styles.threedoutput}
                    style={{borderRadius:12}}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {PieData[7].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                    src={PieData[8].imgSrc}
                    className={styles.barOutput}
                    style={{borderRadius:12}}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {PieData[8].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                    src={PieData[9].imgSrc}
                    className={styles.threedoutput}
                    style={{borderRadius:12}}
                    alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {PieData[9].code}
                    </SyntaxHighlighter>
                </div>
                
            </div>
        </div>
    );
}

export default PieChartGallery;